<script lang="ts">

  import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "$lib/components/ui/dialog"
  import { Label } from "$lib/components/ui/label"
  import { SeparatorLabel } from "$lib/components/ui/separator-label"
  import type { Activity } from "../_types"

  let {
    open,
    setOpen,
    select,
  }: {
    open: boolean
    setOpen: (value: boolean) => void
    select: Activity | undefined
  } = $props()

</script>

<Dialog
  open={open}
  onOpenChange={setOpen}>
  <DialogContent
    class="w-sm"
    onOpenAutoFocus={(event) => event.preventDefault()}>
    <DialogHeader>
      <DialogTitle>Detail</DialogTitle>
      <DialogDescription></DialogDescription>
    </DialogHeader>
    <div class="space-y-3 text-sm">
      <div class="flex gap-3">
        <div class="flex-1">
          <Label>Nomor</Label>
          <div class="text-desc font-mono">{select?.number || "-"}</div>
        </div>
        <div class="flex-1">
          <Label>Tanggal</Label>
          <div class="text-desc font-mono">
            {select?.date.toDateFormat("dd/MM/yyyy", "-") || "-"}
          </div>
        </div>
      </div>
      <div>
        <Label>{select?.customer_type.name || "Tipe"}</Label>
        <div class="text-desc">{select?.customer.name || "-"}</div>
      </div>
      <SeparatorLabel label="Rencana"/>
      <div>
        <Label>Aktifitas Lain</Label>
        <div class="text-desc">{select ? (select.is_other ? "Ya" : "Tidak") : "-"}</div>
      </div>
      <div>
        <Label>Kategori</Label>
        <div class="text-desc">{select?.category.name || "-"}</div>
      </div>
      <div>
        <Label>Aktifitas</Label>
        <div class="text-desc">{select?.name || "-"}</div>
      </div>
      <div>
        <Label>Keterangan</Label>
        <div class="text-desc">{select?.description || "-"}</div>
      </div>
      <div>
        <Label>Tanggal</Label>
        <div class="text-desc font-mono">
          {select?.date.toDateFormat("dd/MM/yyyy", "-") || "-"}
        </div>
      </div>
      <div class="flex gap-3">
        <div class="flex-1">
          <Label>Mulai</Label>
          <div class="text-desc font-mono">
            {select?.at_start.toDateFormat("HH:mm", "-") || "-"}
          </div>
        </div>
        <div class="flex-1">
          <Label>Selesai</Label>
          <div class="text-desc font-mono">
            {select?.at_end.toDateFormat("HH:mm", "-") || "-"}
          </div>
        </div>
      </div>
      <div class="flex gap-3">
        <div class="flex-1">
          <Label>Rutin</Label>
          <div class="text-desc">{select?.routine.name || "-"}</div>
        </div>
        <div class="flex-1">
          <Label>Hari</Label>
          <div class="text-desc">{select?.routine_day.name || "-"}</div>
        </div>
      </div>
      <div class="flex gap-3">
        <div class="flex-1">
          <Label>Rutin Mulai</Label>
          <div class="text-desc font-mono">
            {select?.routine_start ? select?.routine_start.toDateFormat("dd/MM/yyyy", "-") : "-"}
          </div>
        </div>
        <div class="flex-1">
          <Label>Rutin Selesai</Label>
          <div class="text-desc font-mono">
            {select?.routine_end ? select?.routine_end.toDateFormat("dd/MM/yyyy", "-") : "-"}
          </div>
        </div>
      </div>
      <div>
        <Label>Tahap</Label>
        <div class="text-desc">{select?.stage.name || "-"}</div>
      </div>
      <div class="flex gap-3">
        <div class="flex-1">
          <Label>Approval Status</Label>
          <div class="text-desc">{select?.approval_status.name || "-"}</div>
        </div>
        <div class="flex-1">
          <Label>Waktu</Label>
          <div class="text-desc font-mono">
            {select?.approval_at.toDateFormat("dd/MM/yyyy HH:mm", "-") || "-"}
          </div>
        </div>
      </div>
      <div>
        <Label>Oleh</Label>
        <div class="text-desc">{select?.approval_by.name || "-"}</div>
      </div>
      <div>
        <Label>Catatan</Label>
        <div class="text-desc">{select?.approval_description || "-"}</div>
      </div>
    </div>
  </DialogContent>
</Dialog>
